<template>
  <div ref='detail' class="WarehouseDetail-root">
    <!-- <div class="breadcrumb">我要寻仓/仓库详情</div> -->
    <div class="detail-top">
      <div class="banner-box">
        <Slideshow 
          ref="slideShow"
          :files="detail.files || []" 
          @imgurl="fileterImg" 
          @mouseleave="mouseleave" 
          @mouseenter="mouseenter" @toMove="toMove"/>
      </div>
      <div class="detail-box">
        <div class="name">{{nameDispose(detail.warehouseSourceName)}}</div>
        <!-- <div   class="price">
          <p v-if="detail.isShowChargeInfo">
            <span class="price-amount">{{priceParams[temperature] && priceParams[temperature].price || 0}}</span>
            <span>{{priceParams[temperature] && priceParams[temperature].unit || '元/托/天'}}</span>
          </p>
          <span v-else>
            价格请电话联系
          </span>
        </div> -->
        <div class="top-middle">
          <div class="split-tags">
            <div>
              <h4 class="title">仓库温层</h4>
              <div 
              v-for="item in detail.chargeInfos"
               :key="item.temperatureLayerCode"
               class="temperature-item"
              >
                <div class="temperature-item-container">
                  <img class="temperature_icon" :src="temperatureUrl(item.temperatureLayerName)" >
                  <span class="temperature-name">{{item.temperatureLayerName}}</span>
                  <div>
                    <span class="temperature_item_value">制冷区间 {{item.minTemperature || 0}}℃~{{item.maxTemperature || 0}}℃</span>
                    <span class="temperature_item_value">温层面积 {{item.area}}㎡</span>
                  </div>
                </div>
              </div>
              <!-- <el-radio
                v-for="item in detail.chargeInfos"
                :key="item.temperatureLayerCode"
                v-model="temperature"
                class="temperature-item"
                :label="item.temperatureLayerCode"
              >
                <div class="temperature-item-container">
                  <span class="temperature-name">{{item.temperatureLayerName}}</span>
                  <p>
                    <span>制冷区间 {{item.minTemperature || 0}}℃~{{item.maxTemperature || 0}}℃</span>
                  |
                    <span>温层面积 {{item.area}}㎡</span>
                  </p>
                </div>
              </el-radio> -->
            </div>
          </div>
          <div class="address">
            <h4 class="title">仓库地址</h4>
            <div>
              <span class="address_text">{{detail.address}}</span>
              <a-button
                id="checkMap"
                type="link"
                class="checkMap"
                @click="clickCheckMap()"
              >
                查看地图
                <a-icon type="right" />
              </a-button>
            </div>
          </div>
          <!-- <div v-if="detail.label && detail.label.length" class="label">
            <h4 class="title">特色标签</h4>
            <div>
              <span 
                v-for="(tab, index) in detail.label"
                :key="tab"
                class="label-title"
                :style="{backgroundColor: colorList[index % 3].bgColor, color: colorList[index % 3].color}"
              >
                {{tab}}
              </span>
            </div>
          </div> -->
        </div>
        <div class="contact-way">
          <div>
            <div class="contact-phone">
              <div class="contact-portrait">
                <img src="@/assets/img/head_manager_default.png" alt="">
              </div>
              <div class="contact-info">
                <div class="contact-name">
                  {{detail.linkMan||'--'}}
                </div>
                <div class="hotline">
                   <span>区域经理</span>
                  <!-- {{detail.telephone}} -->
                </div>
              </div>
            </div>
            <!-- <a-button
              v-track-click="{ trackName: '仓库详情-立即下单' }"
              class="create-order"
              type="primary"
              @click="createOrder"
            >
              立即下单
            </a-button> -->
             <a-button
              v-track-click="{ trackName: '仓库详情-联系电话' }"
              class="phone_btn"
              type="primary"
              @click="createOrder"
            >
              <img class="phone_icon" src="@/assets/img/phone_icon.png">
              {{detail.telephone||'暂无联系电话'}}
            </a-button>
          </div>
        </div>
      </div>
      <!-- <Amplification v-if="!enlarge" class="fangda" :offset-x="offsetX" :offset-y="offsetY" :imgurl="imgurl" @mousemove.stop="" /> -->
    </div>
    <amplification
      v-if="enlarge"
      class="amplification"
      :offset-x="offsetX"
      :offset-y="offsetY"
      :imgurl="imgurl"
      :img-width="imgWidth"
      @mousemove.stop=""
    />

    <div class="describe-container">
      <div class="describe-detail">
        <div v-if="detail.introduction" class="detail-container">
          <p class="pre-title">库房介绍</p>
          <div :class="['introduce', introMore ? '' : 'introduce-less']">
            {{detail.introduction}}
          </div>
          <show-more :is-more="introMore" @changeMore="changeInfoMore('introMore')" />
        </div>
        <BaseInfo :info-more="infoMore" :base-info-field="baseInfoField" :detail="detail" @changeInfoMore="changeInfoMore">
          <template slot="area">
              <div style="flex:5">
                <el-col :span="4">
                  <span class="area_label">总面积 <span class="area_content">{{detail.area}}㎡</span></span>
                </el-col>
                <el-col :span="4">
                  <span class="area_label">可租面积 <span class="area_content">{{detail.availableArea}}㎡</span></span>
                </el-col>
              </div>
          </template>
        </BaseInfo>
        <!-- <div class="detail-container">
          <p class="pre-title">基本信息</p>
          <div class="basic-info">
            <div class="detail-list">
              <span class="dt-list-title area">仓库面积：</span>
              <div class="dt-list-content item-box">总面积{{detail.area}}㎡</div>
              <div class="dt-list-content item-box">可租面积{{detail.availableArea}}㎡</div>
            </div>
            <div class="detail-list">
              <span class="dt-list-title type">仓库类型：</span>
              <div class="dt-list-content split-tags">
                <span v-for="wharehosetype in detail.type"
                      :key="wharehosetype"
                      class="item-box">{{getWaraType(wharehosetype)}}</span>
              </div>
            </div>
            <div v-if="infoMore">
              <div v-if="detail.facilities && detail.facilities.length" class="detail-list">
                <span class="dt-list-title facilitie">配套设施：</span>
                <div class="dt-list-content split-tags">
                  <span v-for="facil in detail.facilities"
                        :key="facil"
                        class="item-box">{{facil}}</span>
                </div>
              </div>
              <div v-if="detail.equipments && detail.equipments.length" class="detail-list">
                <span class="dt-list-title equipment">库内设备：</span>
                <div class="dt-list-content split-tags">
                  <span v-for="equ in detail.equipments"
                        :key="equ"
                        class="item-box">{{equ}}</span>
                </div>
              </div>
              <div v-if="detail.isSupportPickup || detail.isRecommend" class="detail-list">
                <span class="dt-list-title recommend">服务：</span>
                <div class="dt-list-content split-tags">
                  <span v-if="detail.isSupportPickup" class="item-box">提货服务</span>
                  <span v-if="detail.isRecommend" class="item-box">好仓推荐</span>
                </div>
              </div>
              <div v-if="detail.fireRating && detail.fireRating.length" class="detail-list">
                <span class="dt-list-title fire-control">消防等级：</span>
                <div class="dt-list-content split-tags">
                  <span v-for="apt in detail.fireRating"
                        :key="apt"
                        class="item-box">{{fireRatingOption[apt] || apt}}</span>
                </div>
              </div>
              <div v-if="detail.qualification && detail.qualification.length" class="detail-list">
                <span class="dt-list-title aptitude">资质：</span>
                <div class="dt-list-content split-tags">
                  <span v-for="apt in detail.qualification"
                        :key="apt"
                        class="item-box">{{qualificationOption[apt] || apt}}</span>
                </div>
              </div>
              <div v-if="detail.label && detail.label.length" class="detail-list">
                <span class="dt-list-title feature">特色标签：</span>
                <div class="dt-list-content split-tags">
                  <span v-for="tab in detail.label"
                        :key="tab"
                        class="item-box">{{tab}}</span>
                </div>
              </div>
              <div class="detail-list">
                <span class="dt-list-title time">建设时间：</span>
                <div :class="['dt-list-content', detail.buildTime ? 'item-box' : '']">{{ getBuildTime }}</div>
              </div>
            </div>
          </div>
          <show-more :is-more="infoMore" @changeMore="changeInfoMore('infoMore')" />
        </div> -->
        <div class="detail-container">
          <p class="pre-title">报价信息</p>
          <warehouseInfoTable  title="报价信息" :columns="columns" :charge-infos="chargeInfos"/>
        </div>
        <div class="detail-container">
          <p class="pre-title">商务合作</p>
          <div v-if="detail.wareHouseChargeInfos&&detail.wareHouseChargeInfos.length" class="tab_content">
            <span v-for="(tab,index) in detail.wareHouseChargeInfos"  :key="tab.id" :class="{'tab':true,'active':tabValue===index+1}" @click="handleChangeTab(index)">
              {{ tab.warehouseName }}
            </span>
          </div>
         <div class="business_table_content">
            <div class="time_row">
              <span class="time_label">租赁日期:</span>
              <span class="time_content">
                {{ rentStartTime }} - {{ rentEndTime }}
              </span>
            </div>
            <warehouseInfoTable  title="商务合作" :columns="businessColumn" :charge-infos="chargeInfoList()" />
         </div>
        </div>
      </div>
      <!-- <div class="good-warehouse">
        <recommend @toDetail="toDetail" />
      </div> -->
    </div>
    <div v-if="!loading.content" id="map-box"
         class="map-box">
      <p class="pre-title">地址和交通</p>
      <div class="detail-map-box">
        <Map v-if="show" :detail="detail" />
      </div>
    </div>
    <div class="navigation-box">
      <!-- <div class="next-warehouse" @click="toNext">
        <i class="iconfont icon-next_24x24" />
      </div> -->
      <!-- <div class="to-list" @click="toList">
        <i class="iconfont icon-home_24x24" />
      </div> -->
    </div>
    <div v-if="showCard" class="business-card">
      <div class="card-info">
        <div class="card-portrait">
          <img src="@/assets/img/head_manager_default.png" alt="">
        </div>
        <div class="card-name">
          <p>{{detail.linkMan}}</p>
          <p class="card-position">区域经理</p>
        </div>
      </div>
      <div class="card-phone">{{detail.telephone}}</div>
    </div>
  </div>
</template>

<script>
import { getEntrepotDetails, getEntrepotType, getEntrepotNext } from '@/api/seekWarehouse/seekWarehouse'
import { getToken } from "@/utils/auth";
import { mapState } from 'vuex'
import moment from 'moment'
import { getWareHouseContract } from './api'
import Slideshow from './slideshow.vue'
import Map from './Map.vue'
import { chargeColumns,businessColumns ,baseInfoField} from './constant'
import ShowMore from './component/Showmore.vue'
// import Recommend from './component/Recommend.vue'
import Amplification from './component/Amplification.vue'
import warehouseInfoTable from './component/warehouseInfoTable.vue'
import BaseInfo from './component/baseInfo.vue'
import changwen from './image/changwen.svg'
import lengcang from './image/lengcang.svg'
import lengdong from './image/lengdong.svg'
import henwen from './image/henwen.svg'

const temperatureUrl={
  常温:changwen,
  冷藏:lengcang,
  冷冻:lengdong,
  恒温:henwen,
}
export default {
  name: 'WarehouseDetail',
  components: {
    Slideshow,
    Map,
    ShowMore,
    // Recommend,
    Amplification,
    warehouseInfoTable,
    BaseInfo
  },
  
  data() {
    return {
      baseInfoField,
      id: '',
      show: false,
      detail: {},
      type: [],
      temperature: '',
      priceParams: {},
      chargeInfos: [],
      infoMore: true,
      priceMore: true,
      introMore: true,
      columns: [],
      businessColumns,
      offsetX: 0,
      offsetY: 0,
      flag: true,
      imgurl: '',
      enlarge: false,
      clientHeight: 0,
      showCard: false,
      imgWidth: 0,
      loading:{
        content:false,
      },
      colorList: [
        {
          bgColor: '#E4FDF5',
          color: '#06B880',
        },
        {
          bgColor: 'rgba(79,151,229, 0.15)',
          color: '#4F97E5',
        },
        {
          bgColor: 'rgba(251,148,50, 0.2)',
          color: '#FB9432',
        }
      ],
      tabValue:1,
      warehouseType:[], // 仓库类型
      qualificationOption:[], // 资质
      fireRatingOption:[], // 消防等级
      partEquipments:[], // 配套设施
      wareEquipments:[], // 硬件设施
      safeEquipments:[], // 安保设施
      chargeUnit:[], // 计费单位
      chargeType:[], // 计费类型
    }
  },
  computed: {
    ...mapState('setting', [
      'collapsed'
    ]),
    getWaraType() {
      return function (v) {
        const types = JSON.parse(localStorage.EntrepotType)
        const type = types.filter((item) => item.code === v)[0]
        return type?.name || v
      }
    },
    getBuildTime() {
      const { buildTime } = this.detail
      return (buildTime && `${new Date(buildTime).getFullYear()  }年`) || ''
    },
    temperatureUrl(){
        return (name)=>{
          return temperatureUrl[name]
        }
    },
    businessColumn(){
      return this.businessColumns.map(item=>{
        if(item.dataIndex==='chargeType'){
          console.log(this.chargeType,'chargeType','CHARGE_TYPE_VENEER');
          return {...item,customRender: (text) =>this.chargeType.find(child=>child.value===text)?.label||''}
        }
        return item
      })
    },
    rentStartTime(){
       const {wareHouseChargeInfos=[]} = this.detail
      if(wareHouseChargeInfos&&wareHouseChargeInfos.length&&wareHouseChargeInfos[this.tabValue-1].rentStartTime){
        return moment(wareHouseChargeInfos[this.tabValue-1].rentStartTime).format('YYYY-MM-DD')
      }
      return ''
    },
    rentEndTime(){
       const {wareHouseChargeInfos=[]} = this.detail
      if(wareHouseChargeInfos&&wareHouseChargeInfos.length&&wareHouseChargeInfos[this.tabValue-1].rentEndTime){
        return moment(wareHouseChargeInfos[this.tabValue-1].rentEndTime).format('YYYY-MM-DD')
      }
      return ''
    }
  },
  watch: {
    
    collapsed() {
      this.imgWidth = this.$refs.slideShow?.$el.clientWidth
    },
    priceMore(val) {
      let list = this.detail.chargeInfos
      if (!val) {
        list = list.slice(0,2)
      }
      this.chargeInfos = list
    },
    $route(newVal) {
      if(newVal.query.id !== `${this.id}`) {
        this.fetchData()
      }
    }
  },

  created() {
    this.id = this.$route.query.id
    this.fetchData()
  },
  mounted() {
    this.imgWidth = this.$refs.slideShow?.$el.clientWidth
    // 监听滚动
    this.clientHeight = document.body.clientHeight
    window.addEventListener('mousewheel', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('mousewheel', this.handleScroll)
  },
  methods: {
    chargeInfoList(){
      const {wareHouseChargeInfos=[]} = this.detail
      if(wareHouseChargeInfos&&wareHouseChargeInfos.length){
        return wareHouseChargeInfos[this.tabValue-1].chargeInfos
      }
      return []
    },
    handleScroll() {
      const {scrollTop} = document.getElementById('popContainer')
      // 滚动高度超过屏幕高度，需要显示经纪人卡片
      if (scrollTop >= this.clientHeight) {
        this.showCard = true
      } else {
        this.showCard = false
      }
    },
    mouseleave(){
      this.enlarge = false
    },
    mouseenter(){
      this.enlarge = true
    },
    fileterImg(imgurl){
      this.imgurl = imgurl
    },
    toMove(offsetX, offsetY){
      if(this.flag){
        this.offsetX = offsetX
        this.offsetY = offsetY
        this.flag = false
        setTimeout(()=>{
          this.flag = true
        }, 20)
      }
    },
    async fetchData() {
      await this.getQualificationOption()
      this.loading.content = true;
      try {
        const res = await getEntrepotDetails({ id: this.id })
        this.setDetails(res)
        this.loading.content = false;
      } catch (error) {
        this.loading.content = false;
      }
    },
    setDetails(res) {
      this.detail = res || {}
      this.chargeInfos = res.chargeInfos || []
      this.show = true
      const current = res?.chargeInfos?.[0] || {}
      const priceParams = {}
      const chargeInfos = res.chargeInfos || []
      chargeInfos.forEach(item => {
        priceParams[item.temperatureLayerCode] = {
          price: item.price,
          unit: item.unit
        }
      })
      this.temperature = current.temperatureLayerCode || ''
      this.priceParams = priceParams
      const columns = [...chargeColumns].map(item=>{
        if(item.dataIndex==='chargeType'){
          return {...item,customRender: (text) =>this.chargeType.find(child=>child.value===text)?.label||''}
        }
        return item
      })
      columns.push({
        title: '租金价格',
        dataIndex: 'price',
        customRender: (text,row) => `${text||0}${this.chargeUnit.find(item=>item.value===row.unit)?.label||'元/托/天'}`,
      })
      this.columns = columns
    },
    toDetail(id) {
      if (id !== this.id) {
         this.id = id
         this.fetchData()
      }
      // this.show = false
      // if (id !== this.id) {
      //   this.$router.replace(`?id=${id}$source=${this.$route.query.source}`)
      // }
    },
    // 下一个仓库
    async toNext() {
      const { id, provinceCode, cityCode } = this.detail
      const res = await getEntrepotNext({
        id,
        provinceCode,
        cityCode,
      })
      if (res.id && res.id !== id) {
        this.id = res.id
        this.show = false
        this.$router.replace(`?id=${res.id}&source=${this.$route.query.source}`)
        this.$nextTick(() => {
          this.setDetails(res)
        })
      } else {
        this.$message.destroy()
        this.$message.info({
          icon: (h) => {
            return h('a-icon', {
              style: { color: '#000000', opacity: 0.45 },
              attrs: { type: 'info-circle', theme: 'filled' },
            })
          },
          content: (h) => {
            const innerText = h('span', 
              {
                style: {color: '#171717'}
              }, '当前城市没有更多仓库，请返回列表查看更多仓库')
            const innerIcon = h('a-icon', {
              style: { marginLeft: '26px', color: '#000000', cursor: 'pointer', opacity: 0.45 },
              attrs: { type: 'close' },
              on: { click: () => this.$message.destroy() }
            })
            return h('span', [innerText, innerIcon])
          }
        });
      }
    },
    // 返回列表
    toList() {
      let link = `/seekWarehouses?source=${this.$route.query.source}`
      if (getToken()) {
        link = '/seekWarehouse'
      }
      this.$router.push(link)
    },
    async getQualificationOption() {
      const dictionary = await getEntrepotType({ dictionaryCode: 'WAREHOUSE_QUALIFICATION' }); // 资质
      console.log(dictionary,'this.safeEquipments');
      this.qualificationOption = this.getDictionary(dictionary.dictionaryValues);
      const fireRatingList = await getEntrepotType({ dictionaryCode: 'WAREHOUSE_FIRE_RATING' }); // 消防设施 
      this.fireRatingOption = this.getDictionary(fireRatingList.dictionaryValues);
      const warehouseType = await getEntrepotType({ dictionaryCode: 'WAREHOUSE_TYPE' }); // 仓库类型
      this.warehouseType = this.getDictionary(warehouseType.dictionaryValues);
      const partEquipments = await getEntrepotType({ dictionaryCode: 'PART_EQUIPMENTS' }); // 配套设备
      this.partEquipments = this.getDictionary(partEquipments.dictionaryValues);
      const wareEquipments = await getEntrepotType({ dictionaryCode: 'WARE_EQUIPMENTS' });	// 硬件设施 
      this.wareEquipments = this.getDictionary(wareEquipments.dictionaryValues);
      const safeEquipments = await getEntrepotType({ dictionaryCode: 'SAFE_EQUIPMENTS' }); //	安保设施 
      this.safeEquipments = this.getDictionary(safeEquipments.dictionaryValues);
      const chargeType = await getEntrepotType({ dictionaryCode: 'CHARGE_TYPE' }); //	计费类型  
      this.chargeType = this.getDictionary(chargeType.dictionaryValues);
      const chargeUnit = await getEntrepotType({ dictionaryCode: 'CHARGE_UNIT' }); //	计费单位 
      this.chargeUnit = this.getDictionary(chargeUnit.dictionaryValues); 
      this.baseInfoField=this.baseInfoField.map(item=>{
        if(item.optionsProp){
          return {...item,options:this[item.optionsProp]}
        }
        return item
      })
    },
    getDictionary(dictionary) {
      console.log(dictionary,'dictionary');
      return dictionary.map(item=>({value:item.code,label:item.name}))
    },
    nameDispose(name) {
      return !String(name).substring(16)
        ? name
        : `${String(name).substring(0, 15)}...`
    },
    clickCheckMap() {
      document.getElementById('map-box').scrollIntoView({ behavior: 'smooth' })
    },
    async createOrder() {
      // 根据token跳转，无token时跳转登录页面
      if(this.$route.query.source==='WMS') return
      if (getToken()) {
        const warehouseContract = await getWareHouseContract({
          cargoOwnerCode: this.$store.state.user.customerCode
        })
        // 查询是否开通仓储，开通跳转下单页面，未开通给出弹窗
        if(warehouseContract.STORAGE.length > 0) {
          this.$router.replace({
            path: '/order/createOrder',
            query: {
              type: 'warehouse'
            }
          })
        } else {
          this.$info({
            title: '你还未开通仓储业务，请联系仓库咨询相关业务',
            width: 424,
            class: 'not-opened',
            onOk() {},
          });
        }
       
      } else {
        this.$router.replace('/login')
      }
    },
    changeInfoMore(type) {
      this[type] = !this[type]
    },
    handleChangeTab(index){
      this.tabValue = index+1;
    }
  },
}
</script>

<style lang="less" scoped>
.WarehouseDetail-root {
  margin: 0 30px 30px 30px;
  // max-width: 1600px;
  background: #FFF;
  .navigation-box {
    position: fixed;
    right: 0;
    bottom: 96px;
    z-index: 100;
    > div {
      .iconfont {
        font-size: 24px;
      }
      // width: 48px;
      border-radius: 4px 0px 0px 4px;
      box-shadow: 0px 2px 4px 1px rgba(125, 131, 132, 0.15);
      border-radius: 4px 0px 0px 4px;
      background: #fff;
      color: #171717;
      text-align: center;
      cursor: pointer;
      padding: 8px 12px;
      line-height: normal;
      &:hover {
        background: #06B880;
        color: #Fff;
        &::after {
          display: block;
          width: 24px;
          font-size: 12px;
          margin: 0 auto;
        }
      }
    }
    .next-warehouse {
      margin-bottom: 16px;
      &:hover {
        &::after {
          content: '下个仓库';
        }
      }
    }
    .to-list {
      &:hover {
        &::after {
          content: '返回列表';
        }
      }
    }
  }
  .business-card {
    position: fixed;
    z-index: 111;
    bottom: 32%;
    right: 0;
    width: 144px;
    height: 78px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px 0px 0px 4px;
    color: #fff;
    text-align: center;
    .card-info {
      display: flex;
      margin: 6px 0;
      justify-content: center;
      align-items: flex-end;
      .card-portrait {
        margin-right: 8px;
        img {
          width: 40px;
          height: 40px;
        }
      }
      .card-name {
        text-align: left;
        .card-position {
          font-size: 10px;
        }
      }
    }
    .card-phone {
      font-weight: 500;
    }
  }
  .breadcrumb {
    margin-bottom: 10px;
    margin-left: 12px;
  }
  .detail-top {
    display: flex;
    border-radius: 4px;
    .banner-box {
      width: 55%;
      // max-width: 840px;
      // height: 608px;
      // overflow-x: hidden;
      // border: 1px solid #ccc;
      position: relative;
    }
  }
  .detail-box {
    position: relative;
    flex: 1;
    margin-left: 32px;
    background: #fff;
    padding: 32px 0;
    border-radius: 6px;
    .top-middle {
      padding: 24px 0 3px 0;
      .title {
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        letter-spacing: -0.01px;
        color: #505762;
      }
    }
    .name {
      color: #171717;
      font-size: 22px;
      font-weight: bold;
    }
    
    .split-tags {
      margin-bottom: 10px;
      
      .temperature-item {
        background: #FAFBFC;
        border: 1px solid #F0F2F5;
        border-radius: 4px;
        display: flex;
        align-items: center;
        height: 40px;
        width: 100%;
        padding-left: 16px;
        margin-top: 8px;
        .temperature-item-container {
          display: flex;
          align-items: center;
          font-weight: 400;
          .temperature-name {
            margin-right: 40px;
            font-weight: 500;
            font-size: 16px;
            line-height: 24px;
            color: #171717;
          }
          div {
            display: flex;
            align-items: center;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            letter-spacing: -0.01px;
            color: #505762;
          }
           .temperature_item_value{
              display:inline-flex;
               align-items: center;
              &:last-child::before{
                 content:'';
                height: 18px;
                width: 1px;
                background-color: #ccc;
                display: inline-block;
                margin: 0 8px;
              }
            }
        }
      }
    }
    .area {
      margin-bottom: 10px;
    }
    .address, .label {
      margin-top: 24px;
      font-size: 16px;
      >div {
        margin-top: 8px;
        span {
          font-size: 15px;
        }
      }
    }
    .address {
      .checkMap {
        font-size: 12px;
        padding: 0;
        margin-left: 24px;
        height: 24px;
        line-height: 24px;
        display: inline-flex;
        align-items: center;
      }
    }
    .label {
      margin-bottom: 16px;
      .label-title {
        // background: #F4F5F6;
        border-radius: 2px;
        padding: 5px 10px;
        margin-right: 8px;
        margin-bottom: 8px;
        display: inline-block;
        font-size: 12px;
      }
    }
    .advantage-tags {
      margin-bottom: 16px;
      span {
        margin-right: 4px;
        border-radius: 4px;
        background: #e4fdf5;
        padding: 5px 10px;
        color: #06b880;
        display: inline-block;
        margin-bottom: 4px;
      }
    }
    .price {
      font-size: 16px;
      border-bottom: 1px dashed #E4E7ED;
      padding: 16px 0;
      line-height: 32px;
      .price-amount {
        color: #ED4934;
        font-size: 32px;
        font-weight: bold;
      }
      > span {
        color: #ED4934;
        font-size: 22px;
      }
    }
  }
  .contact-way {
    width: 100%;
    position: absolute;
    bottom: 0;
    padding-top: 16px;
    border-top: 1px solid #E4E7ED;
    > div {
      // height: 54px;
      display: flex;
      align-items: center;
    }
    .contact-phone {
      display: flex;
      align-items: center;
      padding: 18px 55px 18px 23px;
      // background: #EBEDF0;
      // border: 1px solid #EBEDF0;
      border-radius: 4px;
      .contact-portrait {
        margin-right: 12px;
        img {
          width: 56px;
          height: 56px;
        }
      }
      .contact-info {
        color: #171717;
        .contact-name {
            font-size: 16px;
            line-height: 24px;
          span {
            color: #909399;
            font-size: 12px;
            margin-left: 8px;
          }
        }
        .hotline {
          span {
            color: #909399;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
          }
          // font-size: 22px;
          // font-weight: 500;
          // line-height: 26px;
        }
      }
      // img {
      //   width: 20px;
      //   height: 20px;
      // }
      // .tit {
      //   margin: 0 10px 0 4px;
      // }
      // .val {
      //   color: #171717;
      //   font-weight: bold;
      //   font-size: 17px;
      // }
    }
    .create-order {
      margin-left: 54px;
      flex: 1;
      height: 54px;
      background: linear-gradient(239deg, #06B889 0%, #24D69E 100%);
      border-radius: 4px;
      border: none;
      font-size: 18px;
    }
    .phone_btn{
      width: 219px;
      background: #059E84;
      border-radius: 8px;
      height: 56px;
      font-weight: 500;
      font-size: 20px;
      line-height: 28px;
      color: #FFFFFF;
    }
    .phone_icon{
      width: 20px;
      height: 20px;
      margin-right: 12px;
    }
  }
  .describe-container {
    margin-top: 20px;
    align-items: flex-start;
    position: relative;
    .describe-detail {
      width: 100%;
      margin-right: 24px;
    }
    .good-warehouse {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      width: calc(21% - 24px);
    }
  }
  .detail-container {
    background: #fff;
    padding: 30px 0px;
    margin-bottom: 24px;
    border-radius: 6px;
    .introduce {
      margin: 16px 0px 23px 0px;
      font-size: 14px;
    }
    .introduce-less {
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .basic-info {
      padding: 12px 0px 23px;
      margin: 0px 32px;
      .detail-list {
        display: -webkit-box;
        line-height: 54px;
        border-bottom: 1px solid #f5f6f7;
        box-sizing: border-box;
        .dt-list-title {
          display: inline-block;
          width: 100px;
          color: #606266;
          background-repeat: no-repeat;
          background-size: 20px 20px;
          background-position: 0px 16px;
          padding-left: 28px;
          margin-right: 80px;
        }
        // .wuqu {
        //   background-image: url('../../assets/img/detail/icon-detail-wenqu.png');
        // }
        .area {
          background-image: url('../../assets/img/detail/icon-detail-area.png');
        }
        .type {
          background-image: url('../../assets/img/detail/icon-detail-house.png');
        }
        .facilitie {
          background-image: url('../../assets/img/detail/icon_facilities.png');
        }
        .equipment {
          background-image: url('../../assets/img/detail/icon_equipment.png');
        }
        .recommend {
          background-image: url('../../assets/img/detail/icon_service.png');
        }
        .fire-control {
          background-image: url('../../assets/img/detail/icon_fire_control.png');
        }
        .aptitude {
          background-image: url('../../assets/img/detail/icon-detail-zizhi.png');
        }
        .feature {
          background-image: url('../../assets/img/detail/icon-detail-label.png');
        }
        .time {
          background-image: url('../../assets/img/detail/icon-detail-time.png');
        }

        // .dt-list-content {
        //   display: inline-block;
        // }
      }
      .tempera-price {
        color: #ED4934;
      }
    }
  }
  .item-box {
    margin-right: 42px;
    display: inline-block;
    position: relative;
    // display: flex;
    // align-items: center;
    &::before {
      content: '';
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: #06b880;
      margin-right: 8px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: -8px;
    }
  }
  .pre-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #1C2026;
    font-weight: bold;
    display: flex;
    align-items: center;
    &::before {
      content: '';
      width: 4px;
      height: 16px;
      display: block;
      background: #06b880;
      border-radius: 2px;
      margin-right: 8px;
    }
  }
  .map-box {
    background: #fff;
    padding: 30px 0px;
    margin-bottom: 24px;
    border-radius: 6px;
    .detail-map-box {
      // margin: 0px 32px;
      padding-top: 16px;
    }
  }
}
/deep/.slideshow-box .ant-carousel .slick-slide {
  img,video {
    height: 554px;
    width: 100%;
    border-radius: 4px;
  }
}
// /deep/.ant-carousel {
//   height: 496px;
//   .slick-slider {
//     height: 496px;
//   }
//   .slick-list {
//     height: 554px;
//   }
// }
/deep/.ant-carousel .slick-thumb {
  bottom: 0;
  height: 96px;
  width: 100%;
  display: flex !important;
  // justify-content: center;
  li {
    width: 150px;
    height: 96px;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
  }
}
// /deep/.ant-carousel .custom-slick-arrow {
//   top: 510px;
//   width: 34px;
//   height: 96px;
// }
/deep/.slick-prev {
  left: 0px !important;
}
/deep/.slick-next {
  right: 0px !important;
}
/deep/.slick-dots {
  position: initial;
  margin-left: 50%;
  margin-top: 10px;
}
/deep/.anticon {
  vertical-align: -0.43em;
}
.not-opened {
  ::v-deep .ant-modal {
    .ant-modal-body {
      padding: 16px 12px 12px 16px;
    }
  }
}
.area_label{
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #B0B7C2;
 
}
.area_content{
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #1C2026;
  display: inline-block;
  margin-left: 24px;
}
.temperature_icon{
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.tab_content{
  height: 32px;
  display: inline-flex;
  align-items: center;
  background: #F0F2F5;
  border-radius: 3px;
  margin: 24px 0 16px 0;
  .tab{
    padding: 0 8px;
    display:inline-flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    border-radius: 3px;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    color: #505762;
    margin-right: 4px;
    &:last-child{
     margin-right: 0px;
    }
  }
  .active{
    background: #059E84;
    color: #FFFFFF;
  }
}
.time_row{
  margin-bottom: 16px;
  .time_label{
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: -0.01px;
    color: #7E8694;
  }
  .time_content{
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: -0.01px;
    color: #1C2026;

  }
}
</style>

<style lang="less">
.auth-container {
  .WarehouseDetail-root {
    max-width: 1800px;
    padding: 56px  56px 0 56px;
    margin: 0px auto;
  }
}
.not-opened {
  .ant-modal {
    .ant-modal-body {
      padding: 16px 12px 12px 16px;
      &::before {
        display: inline-block;
        width: 24px;
        height: 24px;
        background-image: url('../../assets/img/icon_warning.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
    .ant-modal-confirm-body-wrapper::before {
      display: inline-block;
      width: 24px;
      height: 24px;
      background-image: url('../../assets/img/icon_warning.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .ant-modal-confirm-body {
      display: inline-block;
      margin-left: 8px;
    }
    .anticon {
      display: none;
    }
    .ant-modal-confirm-btns {
      margin-top: 28px;
    }
  }
}
.address_text{
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #1C2026;
  }
  .business_table_content{
    padding: 16px;
    background-color: #FAFBFC;
    border-radius: 8px;
  }
</style>